import trMain from './tr/main.json';
import enMain from './en/main.json';
import trMain2 from './tr/main2.json';
import enMain2 from './en/main2.json';
import trMain3 from './tr/main3.json';
import enMain3 from './en/main3.json';
import { locales as siteBuilderRuntimeLocales } from '@akademi/site-builder-runtime/locales';

/** i18next namespace this package owns. */
export const NS = 'site-builder-blocks';

/**
 * Base translation catalogue for the `site-builder-blocks` namespace.
 *
 * <p>Split across fragments so several modules could be extracted in parallel
 * without two workers ever writing the same file. The fragments deep-merge back
 * into one namespace at boot — a fragment name is a file name only and never
 * appears in a translation key.
 *
 * <p>This is the shipped floor. Tenant overrides fetched from the i18ln backend
 * are layered over it at runtime, so editing a label here changes the default
 * for every institution that has not overridden it.
 */
export const locales = [
  ...siteBuilderRuntimeLocales,
  { ns: NS, resources: { tr: trMain, en: enMain } },
  { ns: NS, resources: { tr: trMain2, en: enMain2 } },
  { ns: NS, resources: { tr: trMain3, en: enMain3 } },
];
